<template>
  <div class="p-3 liff-reservation-success">

    <div class="liff-reservation-success__title" v-if="finishedPageTitle">{{ finishedPageTitle || '預約成功！' }}</div>
    <div class="liff-reservation-success__subtitle" v-if="finishedPageContent" v-html="finishedPageContent"></div>

    <b-card header-tag="header" class="mb-3 wizard-mode-layout__card">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0">{{ bookingPreset.config.finished_page.booking_person_title || '預約人資訊' }}</h6>
        </div>
      </template>

      <template v-if="bookingPreset.config.finished_page.enabled_booking_person_custom_fields">

        <b-form-group
          v-for="field in bookingPreset.config.finished_page.booking_person"
          :key="field.order"
          :label="field.title"
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label-for="input-sm"
          class="mb-3"
        >
          <div class="text-right s-text-sm">{{ getFieldValue(field.matched_key) || '' }}</div>
        </b-form-group>

      </template>
      <template v-else>
        <b-form-group label="姓名" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3">
          <div class="text-right s-text-sm">{{ user.name }}</div>
        </b-form-group>
        <b-form-group v-if="user.mobile_phone" label="電話" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm">
          <div class="text-right s-text-sm">{{ user.mobile_phone }}</div>
        </b-form-group>
      </template>
    </b-card>

    <b-card header-tag="header" class="mb-3 wizard-mode-layout__card">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0">{{ bookingPreset.config.finished_page.booking_info_title || '預約資訊' }}</h6>
        </div>
      </template>

      <template v-if="bookingPreset.config.finished_page.enabled_booking_info_custom_fields">

        <b-form-group
          v-for="field in bookingPreset.config.finished_page.booking_info"
          :key="field.order"
          :label="field.title"
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label-for="input-sm"
          class="mb-3"
        >
          <div class="text-right s-text-sm">{{ getFieldValue(field.matched_key) || '' }}</div>
        </b-form-group>
      </template>
      <template v-else>
        <b-form-group :label="dataModel.serviceField?.title" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3" v-if="selectedServices.length">
          <div class="text-right s-text-sm">{{ selectedServices.map((service) => service.title).join(', ') }}</div>
        </b-form-group>

        <b-form-group label="服務人員" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3" v-if="selectedStaff.name">
          <div class="text-right s-text-sm">{{ selectedStaff.name }}</div>
        </b-form-group>

        <b-form-group :label="dataModel.startTimeField?.title" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3" v-if="selectedScheduleLabel">
          <div class="text-right s-text-sm">{{ selectedScheduleLabel }}</div>
        </b-form-group>

        <b-form-group label="預約結束時間" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3" v-if="endDateTimeForDisplay && !dataModel.shouldHideEndTime">
          <div class="text-right s-text-sm">{{ endDateTimeForDisplay.format(dataModel.startAtFieldFormatIsDate ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm') }}</div>
        </b-form-group>

        <b-form-group :label="dataModel.branchField?.title" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3" v-if="selectedBranch.name">
          <div class="text-right s-text-sm">{{ selectedBranch.name }}</div>
        </b-form-group>
      </template>
    </b-card>

    <b-card header-tag="header" class="mb-3 wizard-mode-layout__card" v-if="fields.length > 0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0">{{ bookingPreset.config.finished_page.form_content_title || '其他資訊' }}</h6>
        </div>
      </template>

      <template v-if="bookingPreset.config.finished_page.enabled_form_content_custom_fields">
        <b-form-group
          v-for="field in bookingPreset.config.finished_page.form_content"
          :key="field.order"
          :label="field.title"
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label-for="input-sm"
          class="mb-3"
        >
          <div class="text-right s-text-sm">{{ getFieldValue(field.matched_key) || '' }}</div>
        </b-form-group>
      </template>
      <template v-else>
        <b-form-group
          v-for="field in fields"
          :key="field._id"
          :label="field.title"
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label-for="input-sm"
          class="mb-3"
        >
          <div class="text-right s-text-sm">{{ extraFormData[field._id] }}</div>
        </b-form-group>
      </template>
    </b-card>


    <div>
      <ShareButton
        v-if="showNextBookingButton"
        class="mb-2"
        variant="s-btn-outline-primary"
        @click="$router.push({ name: dataModel.nextWizardStep('LiffReservation'), params: { bookingPresetId:$route.params.bookingPresetId } })"
      >
        繼續預約
      </ShareButton>
      <ShareButton
        v-if="showGoBookingListButton"
        class="mb-2"
        variant="s-btn-outline-primary"
        @click="$router.push({ name: 'LiffBookingPreset', params: { presetId:$route.params.bookingPresetId } })"
      >
        預約紀錄
      </ShareButton>
      <MemberButton
        button-text="回 LINE 官方帳號"
        type="OA"
      >
      </MemberButton>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import Vue from 'vue'
  import { mapActions, mapGetters, mapState } from 'vuex';
  import ShareButton from "@/components/Page/Liff/Shared/Button";
  import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
  import BookingPresetDataModel from "@/models/BookingPreset.model"
  import DynamicFormField from '@/models/DynamicFormField.model';
  import BookingBusinessLogic from '@/utils/booking/BookingBusinessLogic';
  import liff from "@line/liff";

  const bookingBusinessLogic = Vue.observable(new BookingBusinessLogic())

  export default {
    components: {
      ShareButton,
      MemberButton
    },

    async mounted() {
      await this.fetchPreset()
      this.dynamicFormInput = this.extraFormData
      await this.sendLiffMessage()
    },

    data: () => ({
      dynamicFormInput: {},
    }),

    computed: {
      ...mapGetters('liffAuth', ['user']),
      ...mapGetters('liffBookingWizard', ['selectedServices']),
      ...mapState('liffBookingWizard', [
        'bookingPreset',
        'availableServices',
        'selectedBranch',
        'selectedStaff',
        'selectedSchedule',
        'selectedScheduleLabel',
        'extraFormData',
        'submittedBooking'
      ]),
      dataModel() {
        return new BookingPresetDataModel(this.bookingPreset)
      },
      branchId() {
        return this.$route.query.branch_id
      },
      moment () {
        return moment
      },
      fields() {
        return DynamicFormField.fromArray(_.get(this.bookingPreset, 'config.fields', []))
          .filter(fieldModel => this.dataModel.customerVisibleFieldsInWizard(fieldModel))
          .map(fieldModel => ({
            disabled: true,
            ...fieldModel.flattenedAttributes()
          }))
      },
      serviceDuration() {
        return _.sumBy(this.selectedServices, 'duration')
      },
      endDateTimeForDisplay() {
        return bookingBusinessLogic.endDateTimeToSaveInWizard(this.selectedSchedule.start_at, this.serviceDuration)
      },
      showNextBookingButton() {
        return this.bookingPreset?.config?.finished_page?.enabled_next_booking_button;
      },
      showGoBookingListButton() {
        return this.bookingPreset?.config?.finished_page?.enabled_go_booking_list_button;
      },
      finishedPageTitle() {
        return this.bookingPreset?.config?.finished_page?.title || '';
      },
      finishedPageContent() {
        return this.bookingPreset?.config?.finished_page?.content || '';
      },
    },

    methods: {
      ...mapActions('liffBookingWizard', ['fetchBookingPreset','setSubmittedBooking']),
      async fetchPreset() {
        await this.fetchBookingPreset({ bookingPresetId: this.$route.params.bookingPresetId, branchId: this.branchId })
        bookingBusinessLogic.setBookingPresetDataModel(this.dataModel)
      },
      async sendLiffMessage() {

        const sendMessages = this.bookingPreset.config.finished_page.send_messages

        if (sendMessages.enabled && sendMessages.text) {

          const messageText = sendMessages.text
          const submittedBooking = this.submittedBooking

          // 處理 {{$booking['x']}} - 加入 \s* 允許括號周圍有空格或無空格
          let result = messageText.replace(/\{\{\$booking\s*\['(.+?)'\]\s*\}\}/g, (_, key) => { return submittedBooking[key] || ""; });
          // 處理 {{$booking_data['field_id']}}
          result = result.replace(/\{\{\$booking_data\s*\['(.+?)'\]\s*\}\}/g, (_, fieldId) => {
            const field = submittedBooking.data.find(d => d.field_id === fieldId);

            if (!field) return "";

            if (typeof field.value === 'string') {
              return field.value;
            }

            if (Array.isArray(field.value)) {
              return field.value.map(v => v.text || "").join(", ");
            }

            if (typeof field.value === 'object' && field.value) {
              return field.value.text || "";
            }
            return "";
          });

          // 處理 {{$customer['extra']['x']}}
        result = result.replace(/\{\{\$customer\s*\['extra'\]\s*\['(.+?)'\]\s*\}\}/g, (_, key) => { return this.user.extra[key] || ""; });

        // 處理 {{$customer['x']}}
        result = result.replace(/\{\{\$customer\s*\['(.+?)'\]\s*\}\}/g, (_, key) => { return this.user[key] || ""; });

          await liff
            .sendMessages([
              {
                type: "text",
                text: result,
              },
            ])
            .then(() => {
              console.log("message sent");
            })
            .catch((err) => {
              console.log("error", err);
            });
          return;
        }
      },
      getFieldValue(matchedKey) {

        console.log(matchedKey);

        // 處理 {{$customer['extra']['x']}}
        let result = matchedKey.match(/\{\{\$customer\s*\['extra'\]\s*\['(.+?)'\]\s*\}\}/);


        if (result) {
          return this.user.extra[result[1]];
        }

        // 處理 {{$customer['x']}}
        result = matchedKey.match(/\{\{\$customer\s*\['(.+?)'\]\s*\}\}/);

        if (result) {
          return this.user[result[1]];
        }

        // 處理 {{$booking_data['field_id']}}
        result = matchedKey.match(/\{\{\$booking_data\s*\['(.+?)'\]\s*\}\}/);

        if (result) {

          switch(result[1]) {
            case 'selectedBranch':
              return this.selectedBranch.name;
            case 'selectedStaff':
              return this.selectedStaff.name;
            case 'selectedSchedule':
              return this.selectedSchedule.start_at;
            default:
                return this.extraFormData[result[1]] || "";
          }
        }

        return "";
      },
    }
  }
</script>

<style lang="scss" scoped>
.liff-reservation-success {
  &__title {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 12px;
  }

  &__subtitle {
    font-size: 15px;
    text-align: center;
    margin-bottom: 16px;
  }
}
</style>
